// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1E6-u","form":"styles_form__3N_Ak"};